import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQueryWithHeaders } from '../api';
import { getAccessToken } from '@/utils/api';

import { endpoints } from '../endpoints';

export interface SetVoiceNoteFieldDefaultValueResponse {
  defaultValue: string | number | boolean | null;
}

export const useSetVoiceNoteFieldDefaultValue = () => {
  const queryClient = useQueryClient();
  const { primaryPracticeId: practiceId, primaryOrganizationId: orgId } =
    useSelector(
      (state: {
        login: {
          user: { primaryPracticeId?: string; primaryOrganizationId?: string };
        };
      }) => state.login.user,
    );

  return useMutation({
    mutationFn: async ({
      fieldKey,
      defaultValue,
    }: {
      fieldKey: string;
      defaultValue: string | number | boolean | null;
    }) => {
      const token = getAccessToken();
      return makeAPIRequestReactQueryWithHeaders<SetVoiceNoteFieldDefaultValueResponse>(
        `/${endpoints.ambient.voiceNotes.defaultValue(fieldKey)}`,
        {},
        {
          practice: practiceId,
          org: orgId,
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        'PATCH',
        {
          data: { defaultValue },
        },
      );
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['voice-note-fields'] });
    },
  });
};
